export default "__VITE_ASSET___zrW2eQH__ 400w, __VITE_ASSET__CBy_d9oW__ 800w, __VITE_ASSET__D0e1JFO9__ 1024w";